(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_faq"] && !Shopify.designMode) return;
  try {
    const faqs = document.querySelectorAll('.faq');
  faqs.forEach((faq) => {
    const question = faq.querySelector('.faq__question');
    const answer = faq.querySelector('.faq__answer');

    const answerHeight = answer.querySelector('.faq__answer__inner').offsetHeight;
    answer.style.setProperty('--height', `${answerHeight}px`);

    question.addEventListener('click', () => {
      faq.classList.toggle('faq--active');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_process-grid"] && !Shopify.designMode) return;
  try {
    window.ProcessGridComponent = function () {
    return {
      init: function () {
        const slides = this.$refs.swiper.querySelectorAll('.swiper-slide');
        const numberOfSlides = slides.length;
        const middleSlide = Math.floor(numberOfSlides / 2);

        this.swiper = new Swiper(this.$refs.swiper, {
          breakpoints: {
            750: {
              slidesPerView: 2.4,
              spaceBetween: 70,
            },
          },
          slidesPerView: 1.2,
          spaceBetween: 80,
          centeredSlides: true,
          initialSlide: middleSlide,
          navigation: {
            nextEl: this.$refs.swiper.querySelector('.process-grid__items-mobile-nav-next'),
            prevEl: this.$refs.swiper.querySelector('.process-grid__items-mobile-nav-prev'),
          },
        });

        this.swiper.on('slideChange', () => {
          this.$refs.swiper.classList.toggle('reach-start', this.swiper.activeIndex === 0);
          this.$refs.swiper.classList.toggle('reach-end', this.swiper.activeIndex === this.swiper.slides.length - 1);
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

})();
